/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'project-panel.generic-error.description': 'Vérifiez votre connexion Internet et réessayez.',
  'project-panel.generic-error.title': 'Une erreur est survenue',
  'project-panel.project-icon-header.update-error-description':
    "Impossible de mettre à jour l'icône pour {projectName}",
  'project-panel.project-icon-header.update-error-title': "Une erreur s'est produite.",
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Afficher plus de champs',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Afficher moins',
  'project-panel.project-panel-header.title': 'Projet',
  'project-panel.project-panel-tabs.about-tab-title': 'À propos',
  'project-panel.project-panel-tabs.decisions-title': 'Décisions',
  'project-panel.project-panel-tabs.learnings-title': 'Enseignements',
  'project-panel.project-panel-tabs.risks-title': 'Risques',
  'project-panel.project-panel-tabs.updates-tab-title': 'Mises à jour',
  'project-panel.project-title.edit-button-label': 'Modifier le titre du projet',
  'project-panel.project-title.update-error-description': 'Impossible de mettre à jour le contenu de {projectName}',
  'project-panel.project-title.update-error-title': 'Une erreur est survenue',
  'project-panel.project-title.validation-message': 'Spécifiez un titre pour votre projet',
};
